export default __webpack_public_path__ + "static/media/10_1_logo.33a775b3.png";